module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7OOoV"))).then(() => parcelRequire('2KbAe'));